module.exports = __webpack_public_path__ + "media/images/pc/special_plans/text_day2-5013593384389cfcfe602b12553f7865.svg";